import { StatFlags } from '@mirohq-internal/stats-analytics/dist/lib/StatTypes';
import EventHub from '../dist/lib/event-hub/EventHub.esm.esm.js';

/**
 * This plugin is used to send analytics events to the event hub.
 * It uses stats-analytics package behind the scenes.
 * @see https://github.com/miroapp-dev/stats-analytics
 */ class EventHubAnalyticsProviderPlugin {
    track(data) {
        /**
         * In case of error, batched events aren't cleared and keep trying every 1 second.
         * This is a workaround to send events immediately in development mode and in case of error we just ignore it.
         */ const flags = process.env['NODE_ENV'] === 'development' ? StatFlags.SendImmediately : StatFlags.SendInBatch;
        EventHub?.track(data.payload.event, data.payload.properties, flags);
    }
    identify(data) {
        EventHub?.identify(data.payload.userId);
    }
    page() {
        EventHub?.page();
    }
    constructor(){
        this.name = 'eventhub';
    }
}

export { EventHubAnalyticsProviderPlugin };
